import {
  PlanListView,
  PlanNewView,
  PlanOverviewView,
  PlanShowView,
} from '@/views/authenticated/plans';

import {
  PlanPdfPreviewView,
} from '@/views/authenticated/plans/pdf';

import {
  PlanCoverPageView,
  PlanGeoMapView,
  PlanDocumentView,
  PlanTableView,
  PlanVisionView,
  PlanIntroductionView,
  PlanDiagnosticsView,
  PlanConclusionView,
} from '@/views/authenticated/plans/show/views/index.js';

export default [
  {
    path: '/districts/:district/plans',
    name: 'app_plan_list',
    meta: { title: 'District Plans', redirectAuthenticatedUsers: false, requiresAuthentication: true },
    component: PlanListView,
  },
  {
    path: '/districts/:district/plans/new',
    name: 'app_plan_new',
    meta: { title: 'New Plan', redirectAuthenticatedUsers: false, requiresAuthentication: true },
    component: PlanNewView,
  },
  {
    path: '/districts/:district/plans/:plan/overview',
    name: 'app_plan_overview',
    meta: { title: 'Plan Overview', redirectAuthenticatedUsers: false, requiresAuthentication: true },
    component: PlanOverviewView,
  },
  {
    path: '/districts/:district/plans/:plan/pdf',
    name: 'app_plan_pdf_preview',
    meta: { title: 'Pdf Preview', redirectAuthenticatedUsers: false, requiresAuthentication: true, showNavbar: false, showFooter: false },
    component: PlanPdfPreviewView,
  },
  {
    path: '/districts/:district/plans/:plan',
    name: 'app_plan_show',
    component: PlanShowView,
    meta: { redirectAuthenticatedUsers: false, requiresAuthentication: true },
    redirect: { name: 'app_plan_cover_page' },
    children: [
      {
        path: 'cover-page',
        name: 'app_plan_cover_page',
        meta: { title: 'Coverpage', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanCoverPageView,
      },
      {
        path: 'introduction',
        name: 'app_plan_introduction',
        meta: { title: 'Introduction', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanIntroductionView,
      },
      {
        path: 'diagnostics',
        name: 'app_plan_diagnostics',
        meta: { title: 'Diagnostics', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanDiagnosticsView,
      },
      {
        path: 'manage-catalytic-projects',
        name: 'app_plan_table',
        meta: { title: 'Manage Catalytic Projects', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanTableView,
      },
      {
        path: 'geo-map',
        name: 'app_plan_geo_map',
        meta: { title: 'Geomap', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanGeoMapView,
      },
      {
        path: 'conclusion',
        name: 'app_plan_conclusion',
        meta: { title: 'Conclusion', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanConclusionView,
      },
      {
        path: 'document',
        name: 'app_plan_document',
        meta: { title: 'Document', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanDocumentView,
      },
      {
        path: 'vision-setting',
        name: 'app_plan_vision',
        meta: { title: 'Vision Setting', redirectAuthenticatedUsers: false, suppressUnsavedWarning: true },
        component: PlanVisionView,
      },
    ],
  },
];
